const appConfig = {
  "name": "sponsored-accounts-v2",
  "version": "0.1.0",
  "stage": "prod",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6sh93rjqnQuszg697",
    "clientId": "6iajqn8hbepenip9m42uiustrd",
    "redirectUris": [
      "https://sponsored-accounts-mr.atlas-apps.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://sponsored-accounts-mr.atlas-apps.mit.edu/logout"
    ],
    "scopes": [
      "address",
      "digital-id/search",
      "digital-id/user",
      "email",
      "feature/user",
      "offline_access",
      "openid",
      "phone",
      "profile",
      "user/all",
      "user/finance"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_bCu6BU8d2",
    "userPoolWebClientId": "6iajqn8hbepenip9m42uiustrd",
    "oauth": {
      "domain": "atlas-auth.mit.edu",
      "scope": [
        "digital-id/search",
        "digital-id/user",
        "feature/user",
        "openid",
        "profile",
        "user/all",
        "user/finance"
      ],
      "redirectUris": [
        "https://sponsored-accounts-mr.atlas-apps.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://sponsored-accounts-mr.atlas-apps.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;